var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconCone = function SvgS2IconCone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "ICONS",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.008c-2.266 0-4.375-.374-5.642-1.001-1.02-.503-1.485-1.745-1.058-2.827L8.607 1.928c.23-.573.777-.942 1.393-.942s1.163.37 1.393.942l5.306 13.248.001.004c.427 1.082-.038 2.324-1.058 2.828-1.267.626-3.376 1-5.642 1Zm0-16.522L4.693 15.734c-.141.358.003.767.33.928 1.054.522 2.961.846 4.977.846s3.923-.324 4.978-.845c.326-.161.47-.57.328-.932L10 2.486Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 16.313c-.34 0-.68-.02-1.012-.061a.75.75 0 1 1 .184-1.488c.91.11 1.94.028 2.747-.224a.75.75 0 1 1 .447 1.432 8.081 8.081 0 0 1-2.366.341Z"
  })));
};
export default SvgS2IconCone;